var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundtrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.336 1.46325e-05C12.9366 0.00433318 15.2977 0.952018 17.041 2.49261L18.4425 1.19651C19.0359 0.647833 20.0503 1.03643 20.0503 1.81239V6.67743C20.0503 7.15846 19.6287 7.5484 19.1085 7.5484H13.8477C13.0086 7.5484 12.5884 6.61025 13.1817 6.06155L14.8201 4.54643C13.6089 3.49767 12.0416 2.91674 10.3766 2.90346C6.75066 2.8745 3.69424 5.5881 3.72559 9.05256C3.75534 12.339 6.63654 15.0968 10.3181 15.0968C11.9321 15.0968 13.4574 14.5641 14.6595 13.5887C14.8457 13.4377 15.1268 13.4469 15.3019 13.6088L16.8583 15.0481C17.0495 15.2249 17.04 15.5132 16.8394 15.6808C15.1137 17.1222 12.8268 18 10.3181 18C4.94322 18 0.585977 13.9706 0.585938 9.00008C0.585898 4.03524 4.96723 -0.00887649 10.336 1.46325e-05Z",
    fill: "#595959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundtrip);
export default __webpack_public_path__ + "static/media/roundtrip.9a728e7655be30c018db32e557340e5e.svg";
export { ForwardRef as ReactComponent };